import { Outlet, Route, Routes } from 'react-router-dom';

import { BaseModule, MenuRoute, Modules, VirtualRouteHookProvider, getI18n } from 'scbk-services';

import { CommonConfig, LoansConfig } from 'scbk-loans/config';
import { MockConfig } from 'scbk-loans/mocks';
import { ErrorComponent, RootLayout } from 'scbk-shared-module';
import '../App.css';
import { routeObjects } from './routeObjects';

export const LoansModuleRoutes = () => {
    return (
        <BaseModule
            module={Modules.LOANS}
            moduleConfig={LoansConfig}
            commonConfig={CommonConfig}
            mockConfig={MockConfig}
            metaEnv={import.meta.env}
        >
            <Routes>
                <Route element={<RootLayout i18n={getI18n()} />}>
                    <Route element={<VirtualRouteHookProvider outlet={Outlet} />}>
                        {routeObjects?.map((route) => (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={
                                    <MenuRoute id={route?.id ?? ''} path={route?.fullPath ?? ''} />
                                }
                            />
                        ))}
                    </Route>
                </Route>
                <Route path="*" element={<ErrorComponent errorCode="404" />} />
            </Routes>
        </BaseModule>
    );
};
